import React from 'react';
import Select from 'react-select';
import Const from '../../../../../util/Constants';
import Display from '../../../../../util/Display';
import TemplateField from "./TemplateField";

class FbFieldAssigmentItem extends React.Component {

  constructor(props) {
    super(props);

    this.formats = [
      { label: 'ISO 8601 — Facebook default', value: 'YYYY-MM-DDTHH:mm:ssZ' },
      { label: 'DD/MM/YYYY', value: 'DD/MM/YYYY' },
      { label: 'DD/MM/YYYY HH:mm:ss', value: 'DD/MM/YYYY HH:mm:ss' },
      { label: 'DD/MM/YYYY hh:mm:ss a', value: 'DD/MM/YYYY hh:mm:ss a' },
      { label: 'DD/MM/YY', value: 'DD/MM/YY' },
      { label: 'DD/MM/YY HH:mm', value: 'DD/MM/YY HH:mm' },
      { label: 'MM/DD/YYYY', value: 'MM/DD/YYYY' },
      { label: 'MM/DD/YYYY HH:mm:ss', value: 'MM/DD/YYYY HH:mm:ss' },
      { label: 'MM/DD/YYYY hh:mm:ss a', value: 'MM/DD/YYYY hh:mm:ss a' },
      { label: 'MM/DD/YY', value: 'MM/DD/YY' },
      { label: 'MM/DD/YY HH:mm', value: 'MM/DD/YY HH:mm' },
      { label: 'YYYY/MM/DD', value: 'YYYY/MM/DD' },
      { label: 'YYYY/MM/DD HH:mm:ss', value: 'YYYY/MM/DD HH:mm:ss' },
      { label: 'YYYY/MM/DD hh:mm:ss a', value: 'YYYY/MM/DD hh:mm:ss a' },
      { label: 'YY/MM/DD', value: 'YY/MM/DD' },
      { label: 'YY/MM/DD HH:mm', value: 'YY/MM/DD HH:mm' }
    ];

    this.rowKey = (props.value.key && String(props.value.key).indexOf('tpl_') === 0)
      ? props.value.key
      : `tpl_${Math.random().toString(36).slice(2, 10)}${Math.random().toString(36).slice(2, 6)}`;

    let format = null;
    let zone = null;
    if (props.value.field && props.api_data && props.api_data[props.value.field.value]) {
      format = this.formats.find(f => f.value === props.api_data[props.value.field.value].format);
      zone = props.zones.find(z => z.value === props.api_data[props.value.field.value].zone);
    }

    this.state = { format, zone };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value.field !== this.props.value.field || prevProps.api_data !== this.props.api_data) {
      const crmKey = this.crmKey;
      const api = crmKey && this.props.api_data ? this.props.api_data[crmKey] : null;
      if (api) {
        this.setState({
          format: this.formats.find(f => f.value === api.format) || null,
          zone: this.props.zones.find(z => z.value === api.zone) || null
        });
      }
    }
  }

  get crmKey() { return this.props.value.field ? this.props.value.field.value : ''; }

  get parts() {
    return this.props.value.parts || (this.props.value.key ? [{ t: 'f', k: this.props.value.key }] : []);
  }

  commitParts = (parts) => {
    const fieldTokens = parts.filter(p => p.t === 'f');
    const key = (fieldTokens.length === 1 && parts.length === 1) ? fieldTokens[0].k : this.rowKey;
    this.props.onEdit(this.props.index, { key, field: this.crmKey, parts });
  };

  fieldChange = (field) => {
    const isDate = field && (field.type === Const.DateTime || field.type === Const.Date);
    let parts = this.parts;

    if (isDate) {
      const fieldTokens = parts.filter(p => p.t === 'f');
      const hasText = parts.some(p => p.t === 't' && p.v);
      if (fieldTokens.length > 1 || hasText) {
        if (!window.confirm('Date fields can only use a single Facebook field. Extra fields and text will be removed. Continue?')) return;
      }
      parts = fieldTokens.length ? [fieldTokens[0]] : [];

      const format = this.formats[0];
      const zone = this.props.dZone;
      this.setState({ format, zone });
      this.props.onFormat(field.value, format, zone);
    } else {
      this.setState({ format: null, zone: null });
    }

    const fieldTokens = parts.filter(p => p.t === 'f');
    const key = (fieldTokens.length === 1 && parts.length === 1) ? fieldTokens[0].k : this.rowKey;
    this.props.onEdit(this.props.index, { key, field: field.value, parts });
  };

  onFormatChange = format => { this.setState({ format }); this.props.onFormat(this.crmKey, format, this.state.zone); };
  onZoneChange = zone => { this.setState({ zone }); this.props.onFormat(this.crmKey, this.state.format, zone); };

  render() {
    const isDate = this.props.value.field && (this.props.value.field.type === Const.DateTime || this.props.value.field.type === Const.Date);

    return (
      <div className="formhead col-md-12 pb-3">
        <div className="d-flex align-items-start gap-2" style={{ flexWrap: 'wrap' }}>
          {/* 1. CRM Field Select */}
          <div style={{ minWidth: '180px', flex: '0 1 200px' }}>
            <Select value={this.props.value.field} onChange={this.fieldChange}
              options={this.props.fields} isSearchable={true} placeholder="Select CRM field..." />
          </div>

          {/* 2. Template Field (Resizable) */}
          <div className="flex-grow-1 ml-2" style={{ minWidth: '250px', flex: '1 1 300px' }}>
            <TemplateField
              parts={this.parts}
              fieldOptions={this.props.keyOptions}
              onChange={this.commitParts}
              singleTokenOnly={!!isDate}
              placeholder="Select Facebook fields and/or type text to build the value..."
            />
          </div>

          {/* 3. Date Format & Timezone (Conditional) */}
          {isDate && (
            <>
              <div style={{ minWidth: '140px', flex: '0 1 150px' }}>
                <Select value={this.state.format} onChange={this.onFormatChange}
                  options={this.formats} isSearchable={true} isClearable={true} placeholder="Date format..." />
              </div>
              <div style={{ minWidth: '140px', flex: '0 1 150px' }}>
                <Select value={this.state.zone} onChange={this.onZoneChange}
                  options={this.props.zones} isSearchable={true} isClearable={true} placeholder="Timezone..." />
              </div>
            </>
          )}

          {/* 4. Add/Remove Actions */}
          <div className="d-flex align-items-center pt-1" style={{ flex: '0 0 auto' }}>
            {Display.MultiAction(this.props.index, this.props.onAdd, this.props.onDelete)}
          </div>

        </div>
      </div>
    );
  }
}
export default FbFieldAssigmentItem;